module.exports = __webpack_public_path__ + "static/img/vr6.3981485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vr/vr6.png
// module id = t+2/
// module chunks = 1